import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { CacheService } from '../../ssr-services/cache/cache.service';

@Component({
  selector: 'app-not-found',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  protected cacheService = inject(CacheService);

  public s3BucketAssets = computed(
    () => this.cacheService.cachedContent()?.cache?.config?.webAppConfig?.s3BucketAssets
  );

  public theme = inject(THEME_SIGNAL);

  public readonly GbTheme = GbTheme;
}
